(() => {
  const header = document.querySelector("[data-nvl-header]");
  const menuButton = document.querySelector("[data-nvl-menu-toggle]");
  const mobileMenu = document.querySelector("[data-nvl-mobile-menu]");

  const setHeaderState = () => {
    if (header) header.classList.toggle("is-scrolled", window.scrollY > 12);
  };

  const closeMenu = () => {
    if (!menuButton || !mobileMenu) return;
    menuButton.setAttribute("aria-expanded", "false");
    mobileMenu.classList.remove("is-open");
    document.body.classList.remove("is-menu-open");
  };

  setHeaderState();
  window.addEventListener("scroll", setHeaderState, { passive: true });

  if (menuButton && mobileMenu) {
    menuButton.addEventListener("click", () => {
      const willOpen = menuButton.getAttribute("aria-expanded") !== "true";
      menuButton.setAttribute("aria-expanded", String(willOpen));
      mobileMenu.classList.toggle("is-open", willOpen);
      document.body.classList.toggle("is-menu-open", willOpen);
    });

    mobileMenu.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeMenu));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeMenu();
    });
  }

  document.querySelectorAll("[data-nvl-tabs]").forEach((tabGroup) => {
    const tabs = Array.from(tabGroup.querySelectorAll('[role="tab"]'));
    const scope = tabGroup.closest("[data-nvl-tab-scope]") || document;
    const panels = Array.from(scope.querySelectorAll('[role="tabpanel"]'));
    const status = scope.querySelector("[data-nvl-tab-status]");

    const activate = (tab) => {
      const target = tab.getAttribute("aria-controls");
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute("aria-selected", String(selected));
        item.setAttribute("tabindex", selected ? "0" : "-1");
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== target;
      });
      if (status && tab.dataset.status) status.textContent = tab.dataset.status;
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(tab));
      tab.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
        event.preventDefault();
        const step = event.key === "ArrowRight" ? 1 : -1;
        const next = tabs[(index + step + tabs.length) % tabs.length];
        if (next) {
          activate(next);
          next.focus();
        }
      });
    });
  });

  document.querySelectorAll("[data-nvl-pricing]").forEach((pricing) => {
    const buttons = Array.from(pricing.querySelectorAll("[data-nvl-duration]"));

    const setPeriod = (period) => {
      if (period !== "month" && period !== "lifetime") return;
      pricing.dataset.period = period;
      buttons.forEach((button) => {
        const active = button.dataset.nvlDuration === period;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      });

      pricing.querySelectorAll("[data-nvl-plan-value], [data-nvl-plan-compare]").forEach((node) => {
        const value = period === "lifetime" ? node.dataset.lifetimeValue : node.dataset.monthValue;
        if (typeof value === "string") node.textContent = value;
        if (node.matches("[data-nvl-plan-compare]")) node.hidden = !value;
      });

      pricing.querySelectorAll("[data-nvl-plan-link]").forEach((link) => {
        const href = period === "lifetime" ? link.dataset.lifetimeHref : link.dataset.monthHref;
        const label = period === "lifetime" ? link.dataset.lifetimeLabel : link.dataset.monthLabel;
        if (href) link.href = href;
        if (label) link.textContent = label;
      });
    };

    buttons.forEach((button) => button.addEventListener("click", () => setPeriod(button.dataset.nvlDuration)));
    setPeriod(pricing.dataset.period || "month");
  });

  document.querySelectorAll("[data-nvl-product-form]").forEach((form) => {
    const select = form.querySelector("[data-nvl-variant-select]");
    const price = form.closest("[data-nvl-product]")?.querySelector("[data-nvl-product-price]");
    const submit = form.querySelector('[type="submit"]');
    if (!select) return;

    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (submit) {
        const available = option?.dataset.available === "true";
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableText : submit.dataset.soldOutText;
      }
      const url = new URL(window.location.href);
      url.searchParams.set("variant", select.value);
      window.history.replaceState({}, "", url);
    };

    select.addEventListener("change", updateVariant);
    updateVariant();
  });

  const revealItems = document.querySelectorAll(".nvl-reveal");
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -70px", threshold: 0.08 },
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add("is-visible"));
  }
})();
